import { createContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAllCertificatesGetAllCertificatesDto as CertificatesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export const CertificatesContext = createContext<Loadable<CertificatesDto[]>>({
  loading: false,
  result: null,
  error: null,
});
